<template>
    <v-slider
        prepend-icon="mdi-opacity"
        class="mx-6 my-4"
        color="secondary lighten-1"
        v-model="opacitySublayer"
        hide-details
        min="0"
        max="100"
        step="10"
        thumb-label
        @change="changeOpacitySublayer"
        >
        <template v-slot:prepend>
            <v-icon>mdi-opacity</v-icon>
            <span class="ml-1 mt-1">0%</span>
        </template>
        <template v-slot:thumb-label="{ value }">
            <v-chip label color="secondary lighten-1">
            <strong>{{ value }}%</strong>
            </v-chip>
        </template>
        <template v-slot:append>
            <span class="mt-1">100%</span>
        </template>
    </v-slider>
</template>

<script>
export default {
    name: "LayerOpacity",
    props:['initialOpacity'],
    data: ()=>({
        opacitySublayer: undefined
    }),
    mounted(){
        this.opacitySublayer = this.initialOpacity ?? 100;
    },
    methods:{
        changeOpacitySublayer(opacity){
            this.$emit('changeOpacitySublayer', opacity);
        }
    }
}
</script>

<style>

</style>